import { ActionType } from "../actions/ActionTypes";
// import { Action } from "../actions";

export interface AuthState {
  isLoggedIn: boolean;
  regiserSuccess: boolean;
  user: any;
  error: string;
  loading: boolean;
  user_created: boolean;
  mailotpsuccess: boolean;
  phoneotpsuccess: boolean;
  mailotpverify: boolean;
  phoneotpverify: boolean;
  uid: string;
  isLogin: boolean;
  resetLinkStatus:boolean;
  resetPasswordStatus:boolean;
  loginMethod:string;
}

const initialState: AuthState = {
  isLoggedIn: false,
  regiserSuccess: false,
  mailotpsuccess: false,
  phoneotpsuccess: false,
  user: {},
  error: "",
  loading: false,
  user_created: false,
  mailotpverify: false,
  phoneotpverify: false,
  uid: "",
  isLogin: false,
  resetLinkStatus:false,
  loginMethod:"",
  resetPasswordStatus:false,
};

const reducer = (state: AuthState = initialState, action: any): any => {
  switch (action.type) {

    // clerk authentication
    case ActionType.CLERK_AUTHENTICATION_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        isLogin: false,
      };
    case ActionType.CLERK_AUTHENTICATION_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isLogin: true,
        loading: false,
        loginMethod:"email",
        uid: action.payload.user.uid,
      };
    case ActionType.CLERK_AUTHENTICATION_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
        isLogin: false,
      };

    case ActionType.SEND_EMAIL_OTP_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        user: {},
        regiserSuccess: false,
        mailotpverify: false,
      };
    case ActionType.SEND_EMAIL_OTP_SUCCESS:
      localStorage.setItem("methodId", action.payload.email_id);
      return {
        ...state,
        user: action.payload,
        regiserSuccess: false,
        loading: false,
        mailotpsuccess: true,
      };
    case ActionType.SEND_EMAIL_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
      };

    case ActionType.VERIFY_EMAIL_OTP_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        user: {},
        regiserSuccess: false,
        mailotpverify: false,
      };
    case ActionType.VERIFY_EMAIL_OTP_SUCCESS:
      localStorage.setItem("methodId", action.payload.email_id);
      return {
        ...state,
        user: action.payload,
        regiserSuccess: false,
        loading: false,
        mailotpverify: true,
      };
    case ActionType.VERIFY_EMAIL_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
      };

    case ActionType.SEND_PHONE_OTP_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        phoneotpsuccess: false,
      };
    case ActionType.SEND_PHONE_OTP_SUCCESS:
      return {
        ...state,
        user: action.payload,
        regiserSuccess: false,
        loading: false,
        phoneotpsuccess: true,
      };
    case ActionType.SEND_PHONE_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
        phoneotpsuccess: false,
      };

    case ActionType.VERIFY_PHONE_OTP_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.VERIFY_PHONE_OTP_SUCCESS:
      return {
        ...state,
        user: action.payload,
        regiserSuccess: true,
        loading: false,
        isLogin: true,
        phoneotpverify: true,
        loginMethod:"phone",
        uid: localStorage.getItem("uid") ? localStorage.getItem("uid") : "",
      };
    case ActionType.VERIFY_PHONE_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
      };

    case ActionType.PUT_DETAILS_PHONE_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.PUT_DETAILS_PHONE_SUCCESS:
      return {
        ...state,
        user: action.payload,
        regiserSuccess: true,
        loading: false,
        isLogin: true,
        loginMethod:"phone",
        uid: action.payload.uid,
      };
    case ActionType.PUT_DETAILS_PHONE_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
      };

    case ActionType.PUT_DETAILS_EMAIL_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.PUT_DETAILS_EMAIL_SUCCESS:
      localStorage.setItem("uid", action.payload.user?.uid);
      return {
        ...state,
        user: action.payload,
        regiserSuccess: true,
        loginMethod:"email",
        loading: false,
        isLogin: true,
        uid: action.payload.user?.uid,
      };
    case ActionType.PUT_DETAILS_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
      };

    case ActionType.LOGIN_WITH_EMAIL_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        isLogin: false,
      };
    case ActionType.LOGIN_WITH_EMAIL_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isLogin: true,
        loading: false,
        loginMethod:"email",
        uid: action.payload.user.uid,
      };
    case ActionType.LOGIN_WITH_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
        isLogin: false,
      };

    case ActionType.SEND_LOGIN_OTP_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        isLogin: false,
        phoneotpsuccess: false,
      };

    case ActionType.SEND_LOGIN_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        phoneotpsuccess: true,
      };

    case ActionType.SEND_LOGIN_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        phoneotpsuccess: false,
      };

    case ActionType.LOGIN_WITH_PHONE_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        isLogin: false,
      };
    case ActionType.LOGIN_WITH_PHONE_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isLogin: true,
        loginMethod:"phone",
        loading: false,
        uid: action.payload.user.uid,
      };
    case ActionType.LOGIN_WITH_PHONE_FAIL:
      return {
        ...state,
        error: action.payload,
        regiserSuccess: false,
        loading: false,
        isLogin: false,
      };

    case ActionType.RESET_PASSWORD_SEND_INIT:
      return {
        ...state,
        error: "",
        loading: true,
        resetLinkStatus: false,
      };
    case ActionType.RESET_PASSWORD_SEND_SUCCESS:
      return {
        ...state,
        loading: false,
        resetLinkStatus: true,
      };
    case ActionType.RESET_PASSWORD_SEND_FAIL:
      return {
        ...state,
        resetLinkStatus: false,
        loading: false,
      };

      case ActionType.RESET_PASSWORD_INIT:
        return {
          ...state,
          error: "",
          loading: true,
          resetPasswordStatus: false,
        };
      case ActionType.RESET_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          resetPasswordStatus: true,
        };
      case ActionType.RESET_PASSWORD_FAIL:
        return {
          ...state,
          resetPasswordStatus: false,
          loading: false,
        };

    case ActionType.USER_LOGOUT:
      return {
        ...state,
        isLogin: false,
      };

    default:
      return state;
  }
};

export default reducer;
